// removed by extract-text-webpack-plugin
module.exports = {"_container":"styles___container___1uE6h","_inner":"styles___inner___cRlT-","text":"styles__text___3RQ1R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TempLine/styles.scss
// module id = 7014
// module chunks = 0